<ion-card *ngIf="showItem" (click)="itemClick.emit(item)" [class]="item.tags | tagClasses">
  <ion-img [src]="item.image_url" *ngIf="item.image_url"></ion-img>

  <div class="bottom">
    <ion-text color="white">
      <h2>
        <b [innerHtml]="item.name | caption | translate"></b>
      </h2>
    </ion-text>
  </div>
</ion-card>
